enum ValidationErrors {
	NOT_CSV = 'not_csv',
	MULTIPLE_COLUMNS = 'multiple_columns',
	NO_ROWS = 'no_rows',
	TOO_MANY_ROWS = 'too_many_rows',
	INVALID_RECORDS = 'invalid_rows'
}

export { ValidationErrors };
